import { memo } from 'react'
import VisualMediaTracks from './VisualMediaTracks'
import EmptyTrack from './EmptyTrack'
import { useSelector } from 'react-redux'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import PlusButton from '../../PlusButton'
import * as Styled from './styled'

const Tracks = (props: { preventOnClick: boolean }) => {
  const hasMediaItems = useSelector(projectDataSelectors.hasMediaItems)

  return (
    <Styled.TracksContainer>
      {hasMediaItems ? <VisualMediaTracks {...props} /> : <EmptyTrack />}
      {hasMediaItems && <PlusButton />}
    </Styled.TracksContainer>
  )
}

export default memo(Tracks)
